<template>
    <div class="modal fade modal-upload" id="editGroup" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">

                <div v-show="(loading == true)" class="loading-backdrop">
                    <div class="loading"></div>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal">&times;</button>

                    <form class="" @submit.prevent="editGroup">
                        <div class="center-modal ex-input-center">
                            <div class="center-ttl text-center">
                                {{ $t('group.edit.title') }}
                            </div>

                            <div class="error-message" v-if="alert_error" data-vv-scope='s0'>
                                <div class="d-flex">
                                    <i class="icon-warning mr-2"></i>
                                    <div class="errror-txt">
                                        <p class="fs-14 text-red font600">{{ $t('error.title') }}</p>
                                        <p class="fs-14 text-red font600">{{ alert_error }}</p>
                                    </div>
                                </div>
                            </div>

                            <div v-if="this.editObj.ids.length > 1" data-vv-scope='s1'>
                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('department.general.name') }} <span class="text-red">*</span>
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('departmentId') }">
                                        <select2
                                                id="departmentId"
                                                key="departmentId"
                                                v-model="group.departmentId"
                                                :data-vv-as="$t('department.general.name')"
                                                v-validate.disable="'required'"
                                                class=""
                                                name="departmentId"
                                                :options="selectDepartmentId"
                                                :settings="selectDepartmentIdSettings"
                                                @change="selectDepartmentIdChangeEvent($event)"
                                                @select="selectDepartmentIdEvent($event)"></select2>
                                        <div v-show="errors.has('departmentId')" class="error-text">{{ errors.first('departmentId') }}</div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="this.editObj.ids.length == 1" data-vv-scope='s2'>
                                <!-- Branch -->
                                <div v-if="group.type == groupType.branch.id" v-show="group.type == groupType.branch.id" data-vv-scope='t1'>
                                    <div class="form-input">
                                        <label class="form-input-lb">
                                            {{ $t('company.general.full_name') }} <span class="text-red">*</span>
                                        </label>
                                        <div class="form-input-cnt"
                                            :class="{ 'ex-has-error': errors.has('companyName') }">
                                            <select2
                                                id="companyName"
                                                key="companyName"
                                                v-model="group.companyId"
                                                class="" name="companyName"
                                                :data-vv-as="$t('company.general.full_name')"
                                                v-validate.disable="'required'"
                                                :options="selectCompanyId"
                                                :settings="selectCompanyIdSettings"
                                                @change="selectCompanyChangeEvent($event)"
                                                @select="selectCompanyEvent($event)"></select2>
                                            <div v-show="errors.has('companyName')" class="error-text">{{ errors.first('companyName') }}</div>
                                        </div>
                                    </div>
                                    <div class="form-input">
                                        <label class="form-input-lb">
                                            {{ $t('branch.general.code') }} <span class="text-red">*</span>
                                        </label>
                                        <div class="form-input-cnt"
                                            :class="{ 'ex-has-error': errors.has('branchCode') }">
                                            <input
                                                type="text"
                                                autocomplete="off"
                                                name="branchCode"
                                                key="branchCode"
                                                v-model="group.branchCode"
                                                class="form-control"
                                                :placeholder="$t('place_holder.branch_code')"
                                                :data-vv-as="$t('branch.general.code')"
                                                v-validate.disable="'required|numeric|digits:4'">
                                            <div v-show="errors.has('branchCode')" class="error-text">{{ errors.first('branchCode') }}</div>
                                        </div>
                                    </div>
                                    <div class="form-input">
                                        <label class="form-input-lb">
                                            {{ $t('branch.general.full_name') }} <span class="text-red">*</span>
                                        </label>
                                        <div class="form-input-cnt"
                                            :class="{ 'ex-has-error': errors.has('branchName') }">
                                            <input
                                                type="text"
                                                autocomplete="off"
                                                name="branchName"
                                                key="branchName"
                                                v-model="group.branchName"
                                                class="form-control"
                                                :placeholder="$t('place_holder.branch_full_name')"
                                                :data-vv-as="$t('branch.general.full_name')"
                                                v-validate.disable="'required|min:1|max:255'">
                                            <div v-show="errors.has('branchName')" class="error-text">{{ errors.first('branchName') }}</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Department -->
                                <div v-if="group.type == groupType.department.id" v-show="group.type == groupType.department.id" data-vv-scope='t2'>

                                    <div class="form-input">
                                        <label class="form-input-lb">
                                            {{ $t('branch.general.name') }} <span class="text-red">*</span>
                                        </label>
                                        <div class="form-input-cnt"
                                            :class="{ 'ex-has-error': errors.has('branchId') }">
                                            <select2
                                                    id="branchId2"
                                                    key="branchId2"
                                                    v-model="group.branchId"
                                                    :data-vv-as="$t('branch.general.name')"
                                                    v-validate.disable="'required'"
                                                    class="" name="branchId"
                                                    :options="selectBranchId"
                                                    :settings="selectBranchIdSettings"
                                                    @change="selectBranchIdChangeEvent($event)"
                                                    @select="selectBranchIdEvent($event)"></select2>
                                            <div v-show="errors.has('branchId')" class="error-text">{{ errors.first('branchId') }}</div>
                                        </div>
                                    </div>

                                    <div class="form-input">
                                        <label class="form-input-lb">
                                            {{ $t('department.general.code') }} <span class="text-red">*</span>
                                        </label>
                                        <div class="form-input-cnt"
                                            :class="{ 'ex-has-error': errors.has('departmentCode') }">
                                            <input
                                                type="text"
                                                autocomplete="off"
                                                name="departmentCode"
                                                key="departmentCode"
                                                v-model="group.departmentCode"
                                                class="form-control"
                                                :placeholder="$t('place_holder.department_code')"
                                                :data-vv-as="$t('department.general.code')"
                                                v-validate.disable="'required|numeric|digits:2'">
                                            <div v-show="errors.has('departmentCode')" class="error-text">{{ errors.first('departmentCode') }}</div>
                                        </div>
                                    </div>
                                    <div class="form-input">
                                        <label class="form-input-lb">
                                            {{ $t('department.general.full_name') }} <span class="text-red">*</span>
                                        </label>
                                        <div class="form-input-cnt"
                                            :class="{ 'ex-has-error': errors.has('departmentName') }">
                                            <input
                                                type="text"
                                                autocomplete="off"
                                                name="departmentName"
                                                key="departmentName"
                                                v-model="group.departmentName"
                                                class="form-control"
                                                :placeholder="$t('place_holder.department_full_name')"
                                                :data-vv-as="$t('department.general.full_name')"
                                                v-validate.disable="'required|min:1|max:255'">
                                            <div v-show="errors.has('departmentName')" class="error-text">{{ errors.first('departmentName') }}</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Group -->
                                <div v-if="group.type == groupType.group.id" v-show="group.type == groupType.group.id" data-vv-scope='t3'>

                                    <div class="form-input">
                                        <label class="form-input-lb">
                                            {{ $t('department.general.name') }} <span class="text-red">*</span>
                                        </label>
                                        <div class="form-input-cnt"
                                            :class="{ 'ex-has-error': errors.has('departmentId') }">
                                            <select2
                                                    id="branchId1"
                                                    key="branchId1"
                                                    v-model="group.departmentId"
                                                    :data-vv-as="$t('department.general.name')"
                                                    v-validate.disable="'required'"
                                                    class="" name="departmentId"
                                                    :options="selectDepartmentId"
                                                    :settings="selectDepartmentIdSettings"
                                                    @change="selectDepartmentIdChangeEvent($event)"
                                                    @select="selectDepartmentIdEvent($event)"></select2>
                                            <div v-show="errors.has('departmentId')" class="error-text">{{ errors.first('departmentId') }}</div>
                                        </div>
                                    </div>

                                    <div class="form-input">
                                        <label class="form-input-lb">
                                            {{ $t('group.general.code') }} <span class="text-red">*</span>
                                        </label>
                                        <div class="form-input-cnt"
                                            :class="{ 'ex-has-error': errors.has('groupCode') }">
                                            <input
                                                type="text"
                                                autocomplete="off"
                                                name="groupCode"
                                                key="groupCode"
                                                v-model="group.groupCode"
                                                class="form-control"
                                                :placeholder="$t('place_holder.group_code')"
                                                :data-vv-as="$t('group.general.code')"
                                                v-validate.disable="'required|numeric|digits:3'">
                                            <div v-show="errors.has('groupCode')" class="error-text">{{ errors.first('groupCode') }}</div>
                                        </div>
                                    </div>
                                    <div class="form-input">
                                        <label class="form-input-lb">
                                            {{ $t('group.general.full_name') }} <span class="text-red">*</span>
                                        </label>
                                        <div class="form-input-cnt"
                                            :class="{ 'ex-has-error': errors.has('groupName') }">
                                            <input
                                                type="text"
                                                autocomplete="off"
                                                name="groupName"
                                                key="groupName"
                                                v-model="group.groupName"
                                                class="form-control"
                                                :placeholder="$t('place_holder.group_full_name')"
                                                :data-vv-as="$t('group.general.full_name')"
                                                v-validate.disable="'required|min:1|max:255'">
                                            <div v-show="errors.has('groupName')" class="error-text">{{ errors.first('groupName') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="this.editObj.ids.length >= 1" data-vv-scope='s3' class="d-flex justify-content-center mt-4 pt-4">
                                <div class="pr-2 w-165">
                                    <button type="submit" class="btn btn-pink-53 w-100" :disabled="submitted">
                                        {{ $t('button.ok') }}
                                    </button>
                                </div>

                                <div class="pl-2 w-165">
                                    <button class="btn btn-gray-53 w-100" data-dismiss="modal" type="button" :disabled="submitted">
                                        {{ $t('button.cancel') }}
                                    </button>
                                </div>
                            </div>

                            <div v-if="this.editObj.ids.length < 1" data-vv-scope='s4'>
                                <div class="">
                                    {{ $t('group.general.no_select') }}
                                </div>

                                <div class="d-flex justify-content-center mt-4 pt-4">
                                    <div class="pl-2 w-165">
                                        <button class="btn btn-pink-53 w-100" data-dismiss="modal" type="button">
                                            {{ $t('button.ok') }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* global $ */
import GroupManagementService from '@/services/admin/group.service';
import StorageService from '@/services/common/storage.service';
import { AuthService } from '@/services/common/auth.service';
import Utils from '@/helpers/utils';
import store from '@/store/index';

import { Constants } from "@/helpers/constants";

export default {
    name: 'EditGroupManagement',
    props: {
        editObj: [Object],
        groupObj: [Object],
    },
    data () {
        return {

            alert_success: "",
            alert_error: "",

            loading: false,
            submitted: false,

            selectDepartmentId: [],
            selectDepartmentIdSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.department'),
                data: this.selectDepartmentId,
            },

            selectCompanyId: [],
            selectCompanyIdSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.company'),
                data: this.selectCompanyId,
            },

            selectBranchId: [],
            selectBranchIdSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.branch'),
                data: this.selectBranchId,
            },

            group: {
                id: "",
                companyId: "",
                branchId: "",
                branchCode: "",
                branchName: "",
                departmentId: "",
                departmentCode: "",
                departmentName: "",
                groupCode: "",
                groupName: "",
                type: "",
            },

            groupType: Constants.TypeAdminGroup,
        };
    },
    beforeCreate () {
        this.$forceUpdate();
    },
    created () {
        this.resetModal();
    },
    beforeMount () {
    },
    mounted () {
        let _this = this;
        $("#editGroup").on('show.bs.modal', function () {
            _this.detailGroup();

            if ((_this.editObj.ids.length > 1) || (_this.editObj.ids.length == 1 && _this.group.type == _this.groupType.branch.id)) {
                _this.getAllCompanies();
            }

            if ((_this.editObj.ids.length > 1) || (_this.editObj.ids.length == 1 && _this.group.type == _this.groupType.group.id)) {
                _this.getAllDepartments();
            }

            if (_this.editObj.ids.length == 1 && _this.group.type == _this.groupType.department.id) {
                _this.getAllBranchs();
            }

            store.commit('loading', false);
        });
        $("#editGroup").on('hide.bs.modal', function () {
            _this.resetModal();
            // _this.$emit('unSlectAllGroup');
            store.commit('loading', false);
        });
    },
    computed: {
    },
    watch: {
    },
    methods: {
        resetModal: function resetModal () {
            this.group = {
                companyId: "",
                departmentId: "",
                groupCode: "",
                groupName: "",
            };
            this.type = "";
            this.alert_success = "";
            this.alert_error = "";
            this.loading = false;
            this.submitted = false;
            this.$validator.reset();
        },

        editGroup (e) {
            if (this.editObj.ids.length < 0) {
                return false;
            }

            Utils.trimObject(this.group);

            this.submitted = true;

            this.$validator.validate().then(valid => {
                if (!valid) {
                    this.submitted = false;
                    return false;
                }

                this.loading = true;
                // let _this = this;
                let currentType = this.group.type;

                GroupManagementService.editGroup(this.editObj.ids, this.group)
                    .then(response => {
                        if (response.status == 423) {
                            StorageService.saveExpired();
                            AuthService.doLogout();
                        }
                        if (response.status == 200) {
                            this.alert_success = this.$t('success.update_success');
                            this.alert_error = "";
                            this.$toasted.success(this.alert_success, {icon: 'fa-check'});
                            this.$emit('updateListGroup');

                            let _type = Constants.TypeAdminGroup;
                            if (currentType == _type.branch.id) {
                                this.$emit('updateAllBranchs');
                            } else if (currentType == _type.department.id) {
                                this.$emit('updateAllDepartments');
                            } else if (currentType == _type.group.id) {
                                this.$emit('updateAllGroups');
                            }

                            this.$emit('unSlectAllGroup');

                            $('#editGroup').modal('hide');
                            $('.modal-backdrop').remove();
                        } else {
                            this.alert_success = "";
                            this.alert_error = this.$t('fail.update_fail');

                            let errorCode = Utils.getErrorCode(response);
                            if (errorCode) {
                                this.alert_error = this.$t('error.error_code_' + errorCode);
                            }

                            // this.$toasted.error(this.alert_error, {icon: 'fa-exclamation-triangle'});
                        }

                        if (response.status == 403) {
                            this.alert_success = "";
                            this.alert_error = this.$t('error.error_' + response.status);
                        }

                        this.loading = false;
                        this.submitted = false;
                        this.$validator.reset();
                    }).catch(error => {
                        this.alert_success = "";
                        this.alert_error = this.$t('fail.update_fail');

                        // $('#editGroup').modal('hide');
                        // $('.modal-backdrop').remove();
                        // this.$toasted.error(this.alert_error, {Icon: 'fa-exclamation-triangle'});

                        this.loading = false;
                        this.submitted = false;
                        this.$validator.reset();
                    });
            });
        },

        detailGroup: function detailGroup () {
            this.group = this.groupObj;
        },

        getAllDepartments: function getAllDepartments () {
            GroupManagementService.getAllDepartments()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (!Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return true;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                            };
                            _dataSelect.push(item);
                        });

                        this.selectDepartmentId = _dataSelect;
                    } else {
                        this.selectDepartmentId = [];
                    }
                }).catch(error => {
                    this.selectDepartmentId = [];
                });
            return false;
        },

        selectDepartmentIdChangeEvent (val) {
        },

        selectDepartmentIdEvent ({id, text}) {
        },

        getAllBranchs: function getAllBranchs () {
            GroupManagementService.getAllBranchs()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (!Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return true;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                            };
                            _dataSelect.push(item);
                        });

                        this.selectBranchId = _dataSelect;
                    } else {
                        this.selectBranchId = [];
                    }
                }).catch(error => {
                    this.selectBranchId = [];
                });
            return false;
        },

        getAllCompanies: function getAllCompanies () {
            GroupManagementService.getAllCompanies()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (!Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return ;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                            };
                            _dataSelect.push(item);
                        });

                        this.selectCompanyId = _dataSelect;
                    } else {
                        this.selectCompanyId = [];
                    }
                }).catch(error => {
                    this.selectCompanyId = [];
                });
        },

        selectBranchIdChangeEvent (val) {
        },

        selectBranchIdEvent ({id, text}) {
        },

        selectCompanyChangeEvent (val) {
        },

        selectCompanyEvent ({id, text}) {
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/admin/GroupManagement/Edit.vue